import { SetStateAction } from "jotai/core/types";

export type QuizType = {
  id: string;
  canPlay: boolean;
  variant: QuizVariantEnum;
  questions: QuestionType[];
  allTimePoints?: number;
  prevExtraEntries?: number;
  submissionCount?: number;
  isArcade: boolean;
  quizCompletionsCount?: number;
  prevSmsExtraEntries?: number;
  prevCplExtraEntries?: number;
  prevSmsSelectedCompanies?: string;
};

export enum QuizVariantEnum {
  Arcade = "ARCADE",
  Quiz = "QUIZ",
}

export type QuestionType = {
  id: string;
  variant: QuestionVariantEnum;
  isLocked?: boolean;
  title: string;
  time: number;
} & {
  variant: QuestionVariantEnum.TrueOrFalse;
  options: [OptionType, OptionType];
  media: MediaType;
  cpl: CplType | null;
  smsInfo?: SmsType;
  nextPageUrl?: string | null;
  brandName?: string | null;
};

export enum QuestionVariantEnum {
  TrueOrFalse = "TRUE_OR_FALSE",
  FreeText = "FREE_TEXT",
}

export type OptionType = {
  id: string;
  title: string;
  isCorrect: boolean;
  isSelected: boolean;
};

export type MediaType = {
  logoUrl: string;
  imageUrl: string | null;
  videoUrl: string | null;
};

export type CplType = {
  name: string;
  title: string;
  brandName: string;
  isAccepted: boolean | null;
  isTacAccepted: boolean;
  formPath: string | null;
  tacPath: string | null;
  emailReceiver: string;
  registeredCpl?: boolean;
  isDisabled?: boolean;
  onCplClick?: (isAccepted: boolean) => void;
  bid: number | null;
};

export type SmsType = {
  brandName: string | null;
  question: string | null;
  tacSmsBrand: string | null;
  smsBrandPrivacyPolicy: string | null;
  isAccepted: boolean | null;
  isTacAccepted: boolean;
  wasPreviouslyAccepted: boolean;
  isDisabled: boolean;
  setQuestion: (update: SetStateAction<QuestionType>) => void | Promise<void>;
  canClick: () => boolean;
};

export type SmsDataType = {
  selectedCompanies: string[];
  extraEntries: number;
  phoneNumber: string;
};

export interface QuizQuestionProps {
  readonly id: string;
  readonly questionIndex: number;
  readonly currentQuestionIndex: number;
  readonly showQuestionAds: boolean;
  readonly hasBanner: boolean;
  readonly onSetQuestionWithBanner: (question: number | null) => void;
  readonly onDebounceAutoScroll?: (waitTime: number) => void;
  readonly renderOptInReminder: boolean;
}

export interface QuestionButtonProps {
  readonly isSelected: boolean;
  readonly isCorrect: boolean;
  readonly isSms: boolean;
  readonly isCpl: boolean;
  readonly isReminder: boolean;
  readonly isDisabled: boolean;
  readonly onClick: () => void;
}
